// extracted by mini-css-extract-plugin
module.exports = {"main":"Services_main___ul3a","wrap":"Services_wrap__24Htk","item":"Services_item__2gH-Z","bounce-7":"Services_bounce-7__1O-vr","divider":"Services_divider__178mo"};